import api from "app/api";
import { Options } from "common";
import { UserItem } from "features/users/userApi";

export interface SalesPersonItem {
  id: number;
  user_id?: number | null;
  user?: UserItem | null;
  name: string;
  email: string;
  phone: string;
  active: boolean;
}

export type SalesPersonOptions = Options<"role" | "status" | "user">;

export function getSalesPersonService(scope?: any) {
  return api.getService<SalesPersonItem, SalesPersonItem, SalesPersonOptions>(
    "sales-persons",
    {
      scope,
      //params goes here
    },
  );
}
